import styled from 'styled-components';

import colors from 'themes/Main';

const { blue, gray01, pink, darkBlue, warning } = colors;

export const Container = styled.div`
  padding: 0 32px;
`;

export const Description = styled.p`
  cursor: default;
  user-select: none;
  margin-bottom: 0;
  position: absolute;
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray01};

  span {
    font-weight: 700;
  }

  ${({ type }) =>
    type === 0.0
      ? `
    width: 320px;
    top: 70px;
    left: 100px;

    span {
      color: ${pink};
    }
  `
      : ''}

  ${({ type }) =>
    type === 0.1 || type === 1.0
      ? `
    top: 150px;
    left: 100px;

    span {
      color: ${darkBlue};
    }
  `
      : ''}

  ${({ type }) =>
    type === 0.2
      ? `
      width: 300px;
      top: 130px;
      left: 100px;

      span {
        color: ${pink};
      }
  `
      : ''}

  ${({ type }) =>
    type === 0.3 || type === 1.2
      ? `
      width: 300px;
      top: 250px;
      left: 90px;

      span {
        color: ${pink};
      }
  `
      : ''}

  ${({ type }) =>
    type === 0.4
      ? `
      width: 300px;
      top: 250px;
      left: 90px;

      span {
        color: ${pink};
      }
  `
      : ''}

  ${({ type }) =>
    type === 0.5 || type === 1.3 || type === 2.1
      ? `
      width: 300px;
      top: 140px;
      left: 60px;

      span {
        color: ${warning};
      }
  `
      : ''}

  ${({ type }) =>
    type === 0.6
      ? `
      width: 400px;
      top: 160px;
      left: 100px;

      span {
        color: ${warning};
      }
  `
      : ''}

  ${({ type }) =>
    type === 0.7
      ? `
      width: 250px;
      top: 190px;
      right: 120px;

      span {
        color: ${warning};
      }
  `
      : ''}

  ${({ type }) =>
    type === 1.1
      ? `
      width: 350px;
      top: 280px;
      right: 140px;

      span {
        color: ${pink};
      }
    `
      : ''}

  ${({ type }) =>
    type === 1.4 || type === 1.5
      ? `
      width: 300px;
      top: 180px;
      left: 100px;

      span {
        color: ${warning};
      }
   `
      : ''}

  ${({ type }) =>
    type === 2.0
      ? `
    width: 300px;
    right: 140px;
    top: 240px;

    span {
      color: ${pink};
    }
   `
      : ''}
`;

export const Image = styled.img`
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0 64px;
`;

export const Skip = styled.button`
  color: ${blue};
  text-decoration: underline;
  border: 0;
  background-color: transparent;
  outline: 0;

  &:hover {
    transition: all 300ms ease-in-out;
    opacity: 0.6;
  }
`;
